var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedinPrimary = function SvgLinkedinPrimary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BB3A90",
    stroke: "#BB3A90",
    d: "M8.917 7.834v1.262l.834-.749c.356-.32.822-.513 1.333-.513 1.102 0 2 .897 2 2v3.25H12v-3.042a1.543 1.543 0 0 0-3.083 0v3.042H7.834v-5.25h1.083ZM6 7.834v5.25H4.917v-5.25H6Zm-.541-2.917a.542.542 0 1 1 0 1.084.542.542 0 0 1 0-1.084Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 1.5,
    y: 1.5,
    stroke: "#BB3A90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.34,
    rx: 4
  })));
};
export default SvgLinkedinPrimary;